import { useEffect } from 'react'
import { SITE_ORIGIN } from '../lib/localeSeoRoutes'

/**
 * Schema.org Review graph for on-page customer testimonials (visible quotes only).
 * Helps search and AI systems associate review text with Prime Document Sign.
 */
export function TestimonialsJsonLd({ id = 'pds-testimonials-jsonld', reviews }) {
  useEffect(() => {
    if (typeof document === 'undefined' || !reviews?.length) return undefined

    const graph = reviews.map((r, idx) => {
      const loc = typeof r.location === 'string' && r.location.trim() ? r.location.trim() : ''
      const author = loc
        ? {
            '@type': 'Person',
            name: r.author,
            homeLocation: { '@type': 'Place', name: loc },
          }
        : { '@type': 'Person', name: r.author }
      return {
        '@type': 'Review',
        '@id': `${SITE_ORIGIN}/#customer-review-${idx + 1}`,
        itemReviewed: {
          '@type': 'SoftwareApplication',
          name: 'Prime Document Sign',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          url: `${SITE_ORIGIN}/`,
        },
        author,
        reviewBody: r.reviewBody,
        reviewRating: { '@type': 'Rating', ratingValue: 5, bestRating: 5 },
      }
    })

    const payload = { '@context': 'https://schema.org', '@graph': graph }
    let el = document.getElementById(id)
    if (!el) {
      el = document.createElement('script')
      el.id = id
      el.type = 'application/ld+json'
      document.head.appendChild(el)
    }
    el.textContent = JSON.stringify(payload)
    return () => {
      el?.remove()
    }
  }, [id, reviews])

  return null
}
